import { isKioskTouchMode } from 'lib/hooks/useKioskTouchMode';

export const customStyle = ({
  width,
  height,
  disabled,
  error,
  radius,
  icon,
  isMulti,
  isCreatable,
  rightIcon,
  hasOrder,
  styles = {}
}) => {
  const isKioskTouch = isKioskTouchMode();

  return {
    container: (provided) => ({
      ...provided,
      width: width ?? '100%',
      cursor: disabled ? 'not-allowed' : 'auto',
      ...styles?.container
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '2px 10px',
      flexWrap: isMulti || isCreatable ? 'wrap' : 'nowrap',
      ...styles?.valueContainer
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: disabled ? '#F9FAFA' : '#fff',
      border: '1px solid',
      borderColor:
        state.isFocused && !error
          ? '#54D2FF !important'
          : error
            ? '#FCA5A5 !important'
            : state.selectProps.menuColor,
      borderRadius: radius ?? '6px',
      width: '100%',
      minHeight: height ?? (isKioskTouch ? '48px' : '2.5rem'),
      display: 'flex',
      alignContent: 'center',
      padding: icon ? '0 0 0 22px' : '0',
      fontSize: isKioskTouch ? '1rem' : '0.875rem',
      color: '#DADFE2',
      caretColor: error ? '#EF4444' : '#13B9FF',
      outline:
        state.isFocused && !error
          ? '2px solid #CBF0FD'
          : state.isFocused && error
            ? '2px solid #FEE2E2'
            : '',
      cursor: 'pointer',
      '&:hover': {
        borderColor: !state.isFocused && state.selectProps.menuColor,
        color: '#DADFE2'
      },
      transition: 0,
      ...styles?.control
    }),
    singleValue: (provided) => ({
      ...provided,
      color: disabled ? '#8FA0A7' : '#1B2123',
      position: 'relative',
      top: 'unset',
      transform: 'unset',
      whiteSpace: 'nowrap',
      margin: 'auto 0',
      paddingRight: !!rightIcon && '25px',
      height: 'auto',
      ...styles?.singleValue
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#8FA0A7',
      position: 'relative',
      top: 'unset',
      transform: 'unset',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      ...styles?.placeholder
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      display: 'flex',
      color: '#6D828B',
      fontStyle: 'italic',
      ...styles?.indicatorsContainer
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: rightIcon ? 'none' : 'flex',
      color: '#DADFE2',
      ':hover': {
        color: '#C1CACE'
      },
      padding: '4px 8px 4px 4px',
      ...styles?.dropdownIndicator
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: '#DADFE2',
      ':hover': {
        color: '#C1CACE'
      },
      padding: '4px 0px 4px 4px',
      paddingRight: !!rightIcon && '34px',
      ...styles?.clearIndicator
    }),
    loadingIndicator: (provided) => ({
      ...provided,
      marginRight: rightIcon && '30px'
    }),
    menu: (provided, state) => ({
      ...provided,
      width: '100%',
      color: state.selectProps.menuColor,
      outline: '1px solid #DADFE2',
      opacity: 1,
      zIndex: 9999,
      padding: 0,
      ...styles?.menu
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999, ...styles?.menuPortal }),
    ...(isKioskTouch && {
      menuList: (provided) => ({ ...provided, maxHeight: '320px', ...styles?.menuList })
    }),
    option: (provided, state) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      fontSize: isKioskTouch ? '1rem' : '0.875rem',
      lineHeight: isKioskTouch ? '24px' : '22px',
      color: '#1B2123',
      cursor: 'pointer',
      backgroundColor: state.isSelected ? '#B0EAFF !important' : '',
      ':hover': {
        backgroundColor: '#E6F8FF'
      },
      ':active': {
        backgroundColor: '#E6F8FF'
      },
      margin: state.data.__isNew__ && '2px 4px 0 4px',
      padding: state.data.__isNew__
        ? isKioskTouch
          ? '12px'
          : '8px'
        : isKioskTouch
          ? '12px 16px'
          : '8px 12px',
      width: state.data.__isNew__ && 'calc(100%-8px)',
      borderRadius: state.data.__isNew__ ? '3px' : '0',
      height: 'auto',
      ...styles?.option
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#F5F5F5',
      border: '1px solid',
      borderColor: '#E9EAEB',
      borderRadius: 5,
      cursor: hasOrder ? 'grab' : 'default',
      ...styles?.multiValue
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: 12,
      fontWeight: 500,
      whiteSpace: 'normal',
      margin: 'auto 0',
      color: '#004F6B',
      ...styles?.multiValueLabel
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#004F6B',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5,
      cursor: 'pointer',
      '&:hover': {
        color: '#EF4444',
        backgroundColor: '#FEE2E2'
      },
      ...styles?.multiValueRemove
    })
  };
};
